/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { Industry } from "../enums";
export const candidateIndustrySchema = z.object({
  candidateId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  industryValue: z.nativeEnum(Industry).nullish(),
  updatedAt: z.string().datetime().nullish(),
  yearsOfExperience: z.number().nullish(),
});

export type CandidateIndustry = z.infer<typeof candidateIndustrySchema>;
